import React from 'react';

function SelectComponent(props) {

    return (
        <div className="form-group bmd-form-group">
            <label className="text-dark bmd-label-static">{props.label}</label>
            <select
                className="form-control"
                data-style="btn btn-link"
                name={props.name}
                value={props.value}
                onChange={props.inputChangeHandler}

            >
                <option>Select hotel</option>
                {Object.entries(props.objectMap).map(([key, value]) => {
                    return <option key={key} value={key}>{value}</option>
                })}
            </select>
        </div>
    );
}


export default SelectComponent;


// WEBPACK FOOTER //
// ./src/components/InputSelectComponent/SelectComponent.jsx